/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Attr_Share_NumeratorInputs */

const cs_sreality_attr_share_numerator = /** @type {(inputs: Sreality_Attr_Share_NumeratorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podíl — čitatel`)
};

const en_sreality_attr_share_numerator = /** @type {(inputs: Sreality_Attr_Share_NumeratorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share — numerator`)
};

/**
* | output |
* | --- |
* | "Share — numerator" |
*
* @param {Sreality_Attr_Share_NumeratorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_attr_share_numerator = /** @type {((inputs?: Sreality_Attr_Share_NumeratorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Attr_Share_NumeratorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_attr_share_numerator(inputs)
	return cs_sreality_attr_share_numerator(inputs)
});